import { ReactElement, memo, useRef } from 'react';
import { styled } from 'styled-components';

export interface FormItemWrapperProps {
  label: string;
  labelWidth?: number;
  hideLabel?: boolean;
  inline?: boolean;
  children: ReactElement;
}

const StyledWrapper = styled.div<{ $inline?: boolean }>`
  margin-bottom: 8px;
  display: ${props => props.$inline ? 'flex' : 'block'};
  align-items: center;
  justify-content: space-between;
`;

const StyledLabel = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
`;

/**
 * Form item wrapper
 * @usage
 *
 * @param props
 * @returns
 */
const FormItemWrapper = (props: FormItemWrapperProps) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <StyledWrapper $inline={props.inline}>
      {!props.hideLabel && (
        <StyledLabel style={{ width: props.labelWidth || '200px' }}>
          {props.label}
        </StyledLabel>
      )}
      <div style={{ flex: 1 }} ref={ref}>
        {props.children}
      </div>
    </StyledWrapper>
  );
};

export default memo(FormItemWrapper);

export const FormItem_Styles = {
  UI_ButtonGroup: styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  `,
};
